import { useUserAuthenticationState } from 'module/authentication/state/auth-state';
import { useQueryParams } from 'module/helpers/location-query-params';
import { PageLoading } from 'module/ui/components/atoms/loading';
import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { RouterShell } from 'components/organisms/router-shell/router-shell';

export const ProtectedRoutes = () => {
  const authenticationState = useUserAuthenticationState();
  const navigate = useNavigate();
  const location = useLocation();
  const params = useQueryParams();
  const { hash } = location;

  useEffect(() => {
    if (authenticationState != null && !authenticationState.isAuthenticated) {
      navigate({ pathname: '/login', search: params.toString(), hash });
    }
  }, [authenticationState, hash, navigate, params]);

  if (authenticationState == null) {
    return <PageLoading />;
  }

  return (
    <RouterShell>
      <Outlet />
    </RouterShell>
  );
};
